/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchSubRuleFormWarningsData
 */
export interface SearchSubRuleFormWarningsData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleFormWarningsData
     */
    fareTypes?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SearchSubRuleFormWarningsData
     */
    preferredCarriers?: ValidationMessage;
}

export function SearchSubRuleFormWarningsDataFromJSON(json: any): SearchSubRuleFormWarningsData {
    return SearchSubRuleFormWarningsDataFromJSONTyped(json, false);
}

export function SearchSubRuleFormWarningsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleFormWarningsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fareTypes': !exists(json, 'fareTypes') ? undefined : ValidationMessageFromJSON(json['fareTypes']),
        'preferredCarriers': !exists(json, 'preferredCarriers') ? undefined : ValidationMessageFromJSON(json['preferredCarriers']),
    };
}

export function SearchSubRuleFormWarningsDataToJSON(value?: SearchSubRuleFormWarningsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fareTypes': ValidationMessageToJSON(value.fareTypes),
        'preferredCarriers': ValidationMessageToJSON(value.preferredCarriers),
    };
}


